import React from 'react';
export function Header() {
  return <header className="shadow-sm fixed top-0 left-0 w-full z-50" style={{
    backgroundColor: '#fffdf3'
  }} data-id="element-212">
      <div className="container mx-auto px-4 py-4 flex justify-center items-center" data-id="element-213">
        <div className="text-center" data-id="element-214">
          <div className="font-bold text-amber-800 text-2xl tracking-wide" style={{
          fontFamily: "'Times New Roman', Times, serif"
        }} data-id="element-215">
            PICADAS FÁCILES
          </div>
          <div className="font-bold text-amber-800 text-xl tracking-wide" style={{
          fontFamily: "'Times New Roman', Times, serif"
        }} data-id="element-216">
            LA GUÍA COMPLETA
          </div>
        </div>
      </div>
    </header>;
}